/**
 * @license
 *-------------------------------------------------------------------------------------------
 * Copyright © 2025 Progress Software Corporation. All rights reserved.
 * Licensed under commercial license. See LICENSE.md in the package root for more information
 *-------------------------------------------------------------------------------------------
 */
import { classNames as t } from "@progress/kendo-react-common";
import * as a from "react";
const r = a.forwardRef(
  (e, n) => /* @__PURE__ */ a.createElement("div", { ref: n, ...e, className: t("k-expander-content-wrapper", e.className) }, /* @__PURE__ */ a.createElement("div", { className: "k-expander-content" }, e.children))
);
r.displayName = "KendoReactExpansionPanelContent";
export {
  r as ExpansionPanelContent
};
